var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Panel_White',{staticClass:"px-4 py-4"},[_c('UserSettings_ProfileEdit',{staticClass:"pb-4 separator-bottom",attrs:{"user":_vm.user}}),_c('UserSettings_PasswordEdit',{staticClass:"mt-4"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }